import removeBasePath from './removeBasePath'

import { TCampaignItem } from '../../types/mainNavigation'

export const getEecPromoClickEventForCampaign = (campaign: TCampaignItem, pathName: string) => {
  return {
    event: 'eecPromoClick',
    ecommerce: {
      promoClick: {
        promotions: [
          {
            id: `Sales Module - ${campaign.internalName} | ${campaign.contentfulId}`,
            name: `Flyout Navigation | ${campaign.internalName}`,
            creative: `${removeBasePath(pathName)} | ${removeBasePath(campaign.targetUrl)}`,
            dimension63: 'Sales Module',
          },
        ],
      },
    },
  }
}

export const getEecPromoClickEventForNewsletter = (pathName: string) => {
  return {
    event: 'eecPromoClick',
    ecommerce: {
      promoClick: {
        promotions: [
          {
            id: 'footer',
            name: 'newsletter | footer',
            creative: `${removeBasePath(pathName)} | footer`,
            dimension63: 'Newsletter Module',
          },
        ],
      },
    },
  }
}
